import React from "react";
import { Box, Tooltip } from "@mui/material";
import ViewModuleOutlinedIcon from "@mui/icons-material/ViewModuleOutlined";
import ViewStreamOutlinedIcon from "@mui/icons-material/ViewStreamOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import useTranslation from "../../../shared/hooks/useTranslation";
import { dt } from "../utils/dt";

export type CardLayout = "vertical" | "horizontal" | "compact";

interface CardLayoutToggleProps {
  layout: CardLayout;
  onLayoutChange: (layout: CardLayout) => void;
}

const CardLayoutToggle = ({ layout, onLayoutChange }: CardLayoutToggleProps) => {
  const { translate } = useTranslation("myMachinery");

  const buttons: { key: CardLayout; icon: React.ReactNode; label: string }[] = [
    {
      key: "vertical",
      icon: <ViewModuleOutlinedIcon sx={{ fontSize: "18px" }} />,
      label: translate("verticalLayout"),
    },
    {
      key: "horizontal",
      icon: <ViewStreamOutlinedIcon sx={{ fontSize: "18px" }} />,
      label: translate("horizontalLayout"),
    },
    {
      key: "compact",
      icon: <ViewListOutlinedIcon sx={{ fontSize: "18px" }} />,
      label: translate("compactLayout"),
    },
  ];

  return (
    <Box
      sx={{
        display: "inline-flex",
        borderRadius: dt.radiusSm,
        border: `1px solid ${dt.cardBorder}`,
        overflow: "hidden",
        backgroundColor: dt.cardBg,
      }}
    >
      {buttons.map((btn) => {
        const isActive = layout === btn.key;
        return (
          <Tooltip key={btn.key} title={btn.label} arrow enterDelay={400}>
            <Box
              onClick={() => {
                onLayoutChange(btn.key);
                localStorage.setItem("machinery-card-layout", btn.key);
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "36px",
                height: "32px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                color: isActive ? dt.blue : dt.textMuted,
                backgroundColor: isActive ? dt.blueSoft : "transparent",
                "&:hover": {
                  color: isActive ? dt.blue : dt.textSecondary,
                  backgroundColor: isActive ? dt.blueSoft : "#F8FAFC",
                },
              }}
            >
              {btn.icon}
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default CardLayoutToggle;
